/* eslint-disable max-lines-per-function */
import { MoneyInput } from '@/components';
import { FieldBase } from '@/components/form/fieldBase';
import { useEinstellungenFormContext } from '@/domain/controlling/pages/Umsatzplanung/Einstellungen/Forms/EinstellungenForm/useEinstellungenFormContext';
import { useTranslation } from 'react-i18next';
import { AbsatzProduktivitaetWithAbsatzVorgabeOptions } from './AbsatzProduktivitaetWithAbsatzVorgabeOptions';
import { AbsatzVorgabe } from '@/domain/controlling/entities/tagebuchEinstellungen';

export function UmsatzAbsatzProduktivitaetForm() {
  const { t } = useTranslation();
  const form = useEinstellungenFormContext();

  return (
    <form
      onSubmit={(e) => {
        e.preventDefault();
        e.stopPropagation();
        form.handleSubmit();
      }}
      className="flex flex-col gap-4">
      <div className="flex flex-col gap-2">
        <form.AppField name="zielProduktivitaetUmsatz">
          {(field) => (
            <FieldBase
              label={t(
                'domain.controlling.umsatzplanung.einstellungen.inputs.zielProduktivitaetUmsatz.label',
              )}>
              <MoneyInput
                isIconVisible={false}
                unit={t('domain.controlling.umsatzplanung.ziele.€/Std.')}
                value={field.state.value}
                onBlur={(e) => {
                  field.handleBlur();
                  field.handleChange(e.target.value);
                }}
                onInput={(e) => {
                  field.handleChange(e.currentTarget.value);
                }}
              />
            </FieldBase>
          )}
        </form.AppField>
      </div>
      <div className="flex flex-col gap-2">
        <form.AppField name="zielProduktivitaetAbsatz">
          {(field) => (
            <FieldBase
              label={t(
                'domain.controlling.umsatzplanung.einstellungen.inputs.zielProduktivitaetAbsatz.label',
              )}>
              <AbsatzProduktivitaetWithAbsatzVorgabeOptions
                isValid={field.state.meta.isValid}
                onInput={(e) => {
                  field.handleChange((prev) => ({
                    unit: prev?.unit ?? AbsatzVorgabe.Stueck,
                    value: e.currentTarget.value,
                  }));
                }}
                onOptionsChange={(value) => {
                  field.handleChange((prev) => ({
                    value: prev?.value ?? '',
                    unit: value,
                  }));
                }}
                onBlur={field.handleBlur}
                defaultInputValue={field.state.value?.value ?? ''}
                defaultOption={field.state.value?.unit ?? AbsatzVorgabe.Stueck}
              />
            </FieldBase>
          )}
        </form.AppField>
      </div>
    </form>
  );
}
